import { ConfigStore } from "../../store/modules/config";
import { Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OperationVue } from "../operations/OperationVue";
import IOperationService from "../../services/operations/IOperationService";
import { container } from "@/inversify.config";
import i18n from "@/i18n";
import { DiTokens } from "../../services/diTokens";
import { CardLimitsModel } from "../../models/cardOperations/CardLimitsModel";
import { ContractsStore } from "../../store/modules/contracts";
import { CardLimit } from "../../data/cardLimits";
import { DateType, Dictionary } from "../../data/types/index";

/**
 *  Класс для компоненты модального окна блокировки карты.
 */
export class CardLimitsModalVue extends OperationVue {

  /** Входные параметры */
  @Prop() params!: any;

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */  
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище счетов
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  goToEditLimit(limit: CardLimit): void {
    if (limit.isLimitEditable) {
      const initData: Dictionary<string> = {};
      initData['card'] = this.params.cardRefId;
      initData['limitId'] = limit.SummaCode;
      initData['bankLimit'] = limit.isSum ? limit.GlobalSumLimitStr : limit.GlobalCountLimitStr;
      initData['limit'] = limit.isSum ? limit.IndSumma ? limit.IndSumma.toString() : limit.GlobalSumLimitStr : limit.CountStr;
      let initDataStr: string = '';

      for (const key in initData) {
        initDataStr += `${key}=${initData[key]}`;
        if (key != 'limit')
          initDataStr += '&';
      }

      const catName: string = `${limit.CategoryCaption} ${this.params.card.Data.Alias} ${this.params.card.ShortCardNumber}`;

      this.$router.push(`/operation/0/${this.OperationModel.RespondentCode}?_categoryName=${catName}&${initDataStr}`);
    }
  }

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.CardLimitsService);
    this.OperationModel = (await this.service.init(
      {
        contract: this.params.contract,
        cardId: this.params.card.Data.Id
      },
      this.configStore,
      this.contractsStore
    )) as CardLimitsModel;
    this.loading = false;
  }
}
